import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScShuffleEnd implements ICommand
{

	public HostID : number = 0;
	public GameCount : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.GameCount = ba.readUint32();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		ba.writeUint32(this.GameCount);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScShuffleEnd();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'GameCount(D)='+this.GameCount+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30011;
	}

	public getCmdName() : string
	{
		return 'ScShuffleEnd';
	}

}
